/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Preview_Plan_TitleInputs */

const en_mk_preview_plan_title = /** @type {(inputs: Mk_Preview_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give your idea a clear direction.`)
};

const id_mk_preview_plan_title = /** @type {(inputs: Mk_Preview_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ide yang punya arah jelas.`)
};

/**
* | output |
* | --- |
* | "Give your idea a clear direction." |
*
* @param {Mk_Preview_Plan_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_preview_plan_title = /** @type {((inputs?: Mk_Preview_Plan_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Preview_Plan_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_preview_plan_title(inputs)
	return en_mk_preview_plan_title(inputs)
});